package ai.flowstorm.studio.resources.space

import ai.flowstorm.common.resources.EntityResource
import ai.flowstorm.studio.common.state.AppState
import ai.flowstorm.studio.model.ProfileRecord
import ai.flowstorm.studio.model.User
import ai.flowstorm.studio.ui.data.ProfileRecordUserSearchForm
import io.kvision.rest.HttpMethod
import io.kvision.state.ObservableList
import io.kvision.state.observableListOf
import kotlinx.coroutines.coroutineScope
import kotlinx.serialization.builtins.ListSerializer

class ProfileRecordResource(
    private val user: User,
    entities: ObservableList<ProfileRecord> = observableListOf()
) : EntityResource<ProfileRecord>(
    serializer = ProfileRecord.serializer(),
    entities = entities
) {
    override val resourceUri: String
        get() = "/spaces/${AppState.state.spaceId!!.value}/profileRecords/user/${user.id.value}"

    suspend fun load(query: String) = coroutineScope {
            remoteCall(
                createEntityUri() + query,
                null,
                HttpMethod.GET,
                deserializer = ListSerializer(serializer)
            )
        }

    companion object {
        fun buildQuery(entity: User, data: ProfileRecordUserSearchForm.FormData): String {
            val filters = mapOf(
                ProfileRecordUserSearchForm.FormData::search.name to data.search,
                "language" to entity.language,
            )
            val query = filters.mapNotNull { (key, value) -> if (value != null) "${key}=${value}" else null }.joinToString("&")
            return if (data.search.isNullOrBlank()) "" else "/search?${query}"
        }
    }
}
